import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { YesNoDialogComponent } from './yes-no-dialog.component'

@NgModule({
    declarations: [YesNoDialogComponent],
    exports: [YesNoDialogComponent],
    imports: [CommonModule],
})
export class YesNoDialogModule {}
